import React, { forwardRef, type Ref } from 'react';
import { IconButton } from '@atlaskit/button/new';
import type { CommonNavMenuButtonProps } from './types.tsx';

export const CommonNavMenuButton = forwardRef(
	({ onClick, icon, ...props }: CommonNavMenuButtonProps, ref: Ref<HTMLButtonElement>) => {
		return (
			<IconButton
				{...props}
				icon={icon}
				onClick={onClick}
				ref={ref}
				spacing="compact"
				appearance="subtle"
			/>
		);
	},
);
